import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography } from '@mui/material';
import apis from '@src/apis';
import { useSelector } from 'react-redux';
import UserOrderInfo from './UserOrderInfo';
import { StyledOrderInfo } from './index.style';
import Order from './Order';

const OrderInfo = ({
  totalPrice = 0,
  isPhoneNumberValid,
  onChangePhoneNumberValid,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const [countryCode, setCountryCode] = useState([]);

  const { accessToken } = useSelector((state) => state.auth);
  // With sms user always show price in VND
  const isVietNam = true;

  const fetCodeCountry = async () => {
    const data = await apis.country.getAllCountry(accessToken);
    setCountryCode(data || []);
  };
  useEffect(() => {
    fetCodeCountry();
  }, []);

  return (
    <StyledOrderInfo>
      <Typography className="title">{t('orderInfo')}</Typography>
      <UserOrderInfo
        countryCode={countryCode || []}
        isPhoneNumberValid={isPhoneNumberValid}
        onChangePhoneNumberValid={onChangePhoneNumberValid}
      />
      <Order />
      <Divider />
      <Box className="total">
        <Typography className="info-title">{t('total')}</Typography>
        <Typography className="info-title">
          {!isVietNam && (
            <span className="discount-unit-price font-size-16">$</span>
          )}
          {isVietNam && (
            <span className="discount-unit-price underline font-size-16">
              đ
            </span>
          )}
          {totalPrice.toLocaleString(language)}
        </Typography>
      </Box>
    </StyledOrderInfo>
  );
};

export default OrderInfo;
